module.exports = __webpack_public_path__ + "img/title.d292797d.png";